import {DialogoEnum, TipoOpcionEnum} from '../Enumeraciones/MensajeEnumeraciones.enum';

export class Dialogo
{
  public Tipo: DialogoEnum = DialogoEnum.normal;
  public Titulo: string = "";
  public Mensaje: string = "";
  public Opcion: Array<DialogoOpcion> = [];

  constructor(init?:Partial<Dialogo>)
  {
    Object.assign(this, init);
  }
}

export class DialogoOpcion
{
  public Titulo: string = "";
  public Valor: number = 0;
  public Tipo : TipoOpcionEnum = TipoOpcionEnum.positivo;

  constructor(init?:Partial<DialogoOpcion>)
  {
    Object.assign(this, init);
  }
}

export class Defer<T>
{
  promise: Promise<T>;
  resolve!: (value?: T | PromiseLike<T>) => void;
  reject!:  (reason?: any) => void;

  constructor()
  {
    this.promise = new Promise<T>((resolve, reject) =>
    {
      this.resolve = resolve;
      this.reject  = reject;
    });
  }
}

